import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import Select from "../select/Select";
import { useUser } from "../../classes/contexts/UserContext";

export function LangSwitcher({ className = "" }) {
  const lang = useSelector(state => state.i18n.lang);
  const [selectedLanguage, setSelectedLanguage] = useState(lang);

  const supportedLangs = useSelector(state => state.i18n.supportedLangs);
  const { updateUserLanguage } = useUser();

  // Sync selected language with Redux state
  useEffect(() => {
    setSelectedLanguage(lang);
  }, [lang]);

  const handleSelectChange = event => {
    const language = event.target.value;
    if (lang !== language && language != null) {
      updateUserLanguage(language);
    }
  };

  return (
    <Select
      items={Object.keys(supportedLangs)}
      onChange={handleSelectChange}
      selectedItem={selectedLanguage}
      className={`${className}`}
    />
  );
}

export default LangSwitcher;
